import { useState } from "react";
import { Actions } from "../../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../../Utils/storeUtils";
import { verifyPassword } from "../../../../../../../Utils/roconConstants";
import { devToolsConst } from "../../../../../../../Utils/sitePages";
import { Grid2 } from "@mui/material";
import styles from "../DevTools.module.scss";
import CustomInput from "../../../../../../../GlobalComponents/CustomInput/CustomInput";
import ModalPopup from "../../../../../../../GlobalComponents/Popup/ModalPopup";

const SftpPopup = (props) => {
  const {
    setSftpPopup,
    sftpPopup,
    siteData,
    selectedDomain,
    successSFTP,
    errorSFTP,
  } = props;
  const [sftpLoading, setSFTPLoading] = useState(false);
  const [sftpUser, setSftpUser] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    password: "",
    passworderror: false,
    passworderrormessage:
      "Requires at least 8 characters with one capital letter, one numeric character, and one special character",
  });

  const flushStateVariables = () => {
    setSFTPLoading(false);
    setSftpPopup(false);
    setErrorMessage(false);
    setIsFormValid(false);
    setSftpUser(
      `${
        selectedDomain?.environment === "STAGING"
          ? selectedDomain.domainName
          : siteData?.siteName || ""
      }-`
    );
    setErrorMessage({
      password: "",
      passworderror: false,
      passworderrormessage: devToolsConst.ERROR_MSG,
    });
  };

  const createSFTP = () => {
    if (!isFormValid) return;
    setSFTPLoading(true);
    let suffix = sftpUser.slice(
      (selectedDomain?.environment === "STAGING"
        ? selectedDomain.domainName
        : siteData?.siteName
      )?.length + 1
    );
    getStore().dispatch({
      type: Actions.API_CREATE_SFTP_USER,
      data: {
        domainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.siteName,
        siteId: siteData?.siteId,
        secretNameSuffix: suffix,
        secretPassword: errorMessage.password,
      },
      meta: {
        onSuccess: () => {
          successSFTP();
          flushStateVariables();
        },
        onError: () => {
          errorSFTP();
          flushStateVariables();
        },
      },
    });
  };

  const validateForm = () => {
    const isUsernameValid =
      typeof sftpUser === "string" &&
      sftpUser.startsWith(
        selectedDomain?.environment === "STAGING"
          ? selectedDomain.domainName
          : siteData?.siteName + "-"
      ) &&
      sftpUser?.length >
        (selectedDomain?.environment === "STAGING"
          ? selectedDomain.domainName
          : siteData?.siteName
        ).length +
          1;
    const isPasswordValid =
      errorMessage.password.trim() !== "" &&
      verifyPassword(errorMessage.password);
    if (isFormValid !== isUsernameValid && isPasswordValid) {
      setIsFormValid(isUsernameValid && isPasswordValid);
    }
    return isUsernameValid && isPasswordValid;
  };

  return (
    <>
      <ModalPopup
        trigger={sftpPopup}
        header={devToolsConst.SFTP_HEADER}
        backPopup={"Cancel"}
        backOnClick={() => flushStateVariables()}
        nextpopup={"Add SFTP User"}
        nextOnClick={createSFTP}
        loading={sftpLoading}
        disabled={!validateForm()}
      >
        <Grid2 className={styles.input}>
          <Grid2 className={styles.display}>
            <CustomInput
              title={devToolsConst.INPUT_TITLE}
              value={
                sftpUser ||
                `${
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData?.siteName || ""
                }-`
              }
              setValue={(value) => {
                const siteName =
                  selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData?.siteName || "";
                const prefix = `${siteName}-`;
                if (!value.startsWith(prefix)) {
                  setSftpUser(prefix);
                } else {
                  setSftpUser(value);
                }
                validateForm();
              }}
            />
          </Grid2>
          <Grid2 className={styles.password}>
            <CustomInput
              title={"Password"}
              placeholder={"Enter Password"}
              value={errorMessage.password}
              setValue={(value) => {
                setErrorMessage({
                  ...errorMessage,
                  password: value,
                  passworderror: value.trim() === "" || !verifyPassword(value),
                });
                validateForm();
              }}
              password={true}
              passwordview={true}
              error={errorMessage.passworderror}
              errorMessage={
                errorMessage.passworderror
                  ? errorMessage.passworderrormessage
                  : ""
              }
            />
          </Grid2>
        </Grid2>
      </ModalPopup>
    </>
  );
};

export default SftpPopup;
